module.exports = __webpack_public_path__ + "static/media/shape2_0.18a5c84e.obj";